module.exports = __webpack_public_path__ + "static/media/sort-amount-up-solid.8c37d4d1.svg";